import * as yup from 'yup';

import i18n from '../../../../i18n/configs';

const urlValidation = yup.string().url(i18n.t('validation.error.url'));

const requiredValidation = yup
  .string()
  .required(i18n.t('validation.error.required'));

const imageValidation = yup
  .mixed()
  .test('type', i18n.t('validation.error.image'), (value: FileList): boolean =>
    value
      ? String(value).includes('.jpg') ||
        String(value).includes('.jpeg') ||
        String(value).includes('.png') ||
        String(value).includes('.webp') ||
        String(value).includes('.gif') ||
        String(value).includes('.svg') ||
        String(value).includes('.JPG') ||
        String(value).includes('.JPEG') ||
        String(value).includes('.PNG') ||
        String(value).includes('.WEBP') ||
        String(value).includes('.GIF') ||
        String(value).includes('.SVG')
      : true
  );

export const clientRegisterCompanySchema = yup.object().shape({
  address: yup.string().max(250, i18n.t('validation.error.below250')),
  agentFlg: yup
    .bool()
    .oneOf([true, false], i18n.t('validation.error.required')),
  agentLists: yup.string(),
  capital: yup
    .number()
    .min(0, i18n.t('validation.error.numberMin'))
    .max(1000000000000000, i18n.t('validation.error.below1000000000000000'))
    .transform((value: number) => (isNaN(value) ? undefined : value)),
  city: requiredValidation.max(250, i18n.t('validation.error.below250')),
  companyUrl: urlValidation
    .required(i18n.t('validation.error.required'))
    .max(250, i18n.t('validation.error.below250')),
  employees: yup
    .number()
    .nullable()
    .transform(
      (value, originalValue) =>
        (isNaN(Number(originalValue))
          ? originalValue
          : Number(originalValue)) as number
    )
    .test(
      'is-number',
      i18n.t('validation.error.number'),
      (value) =>
        value === undefined ||
        value === null ||
        (value !== undefined && value !== null && !isNaN(Number(value)))
    )
    .min(0, i18n.t('validation.error.above1'))
    .max(100000000, i18n.t('validation.error.below100000000'))
    .typeError(i18n.t('validation.error.number')),
  fiscalMonth: yup.number().nullable(),
  foundationYear: yup
    .number()
    .transform((value: number) => (isNaN(value) ? undefined : value))
    .nullable()
    .min(999, i18n.t('validation.error.yearEstablished'))
    .max(10000, i18n.t('validation.error.yearEstablished'))
    .required(i18n.t('validation.error.required')),
  image: imageValidation,
  industryType: yup.number(),
  introduction: requiredValidation.max(
    2000,
    i18n.t('validation.error.below2000')
  ),
  listedFlg: yup
    .bool()
    .oneOf([true, false], i18n.t('validation.error.required')),
  prefecture: yup.number(),
  products: yup.array().of(
    yup.object({
      productName: yup.string().max(250, i18n.t('validation.error.below250')),
      productUrl: yup
        .string()
        .url(i18n.t('validation.error.url'))
        .max(250, i18n.t('validation.error.below250'))
    })
  ),
  representative: yup.string().max(250, i18n.t('validation.error.below250')),
  resources_0: urlValidation.max(250, i18n.t('validation.error.below250')),
  resources_1: urlValidation.max(250, i18n.t('validation.error.below250')),
  resources_2: urlValidation.max(250, i18n.t('validation.error.below250')),
  resources_3: urlValidation.max(250, i18n.t('validation.error.below250')),
  resources_4: urlValidation.max(250, i18n.t('validation.error.below250')),
  sales: yup
    .number()
    .oneOf(
      [1, 10, 20, 30, 40, 50, 60, 70, 80, 90],
      i18n.t('validation.error.required')
    ),
  sns_0: urlValidation.max(250, i18n.t('validation.error.below250')),
  sns_1: urlValidation.max(250, i18n.t('validation.error.below250')),
  sns_2: urlValidation.max(250, i18n.t('validation.error.below250')),
  sns_3: urlValidation.max(250, i18n.t('validation.error.below250')),
  sns_4: urlValidation.max(250, i18n.t('validation.error.below250')),
  zipcode: yup
    .string()
    .matches(/^[0-9]{7}$/, i18n.t('validation.error.zipcode'))
});

export const registerCompanySchemaWhenClient = yup.object().shape({
  address: yup.string().max(250, i18n.t('validation.error.below250')),
  agentFlg: yup
    .bool()
    .oneOf([true, false], i18n.t('validation.error.required')),
  agentLists: yup.string(),
  capital: yup
    .number()
    .nullable()
    .transform(
      (value, originalValue) =>
        (isNaN(Number(originalValue))
          ? originalValue
          : Number(originalValue)) as number
    )
    .test(
      'is-number',
      i18n.t('validation.error.number'),
      (value) =>
        value === undefined ||
        value === null ||
        (value !== undefined && value !== null && !isNaN(Number(value)))
    )
    .min(0, i18n.t('validation.error.above1'))
    .max(1000000000000000, i18n.t('validation.error.below1000000000000000'))
    .typeError(i18n.t('validation.error.number')),
  city: requiredValidation.max(250, i18n.t('validation.error.below250')),
  employees: yup
    .number()
    .nullable()
    .transform(
      (value, originalValue) =>
        (isNaN(Number(originalValue))
          ? originalValue
          : Number(originalValue)) as number
    )
    .test(
      'is-number',
      i18n.t('validation.error.number'),
      (value) =>
        value === undefined ||
        value === null ||
        (value !== undefined && value !== null && !isNaN(Number(value)))
    )
    .min(0, i18n.t('validation.error.above1'))
    .max(100000000, i18n.t('validation.error.below100000000'))
    .typeError(i18n.t('validation.error.number')),
  fiscalMonth: yup.number(),
  foundationYear: yup
    .number()
    .transform((value: number) => (isNaN(value) ? undefined : value))
    .nullable()
    .min(999, i18n.t('validation.error.yearEstablished'))
    .max(10000, i18n.t('validation.error.yearEstablished'))
    .required(i18n.t('validation.error.required')),
  image: imageValidation,
  industryType: yup.number(),
  introduction: requiredValidation.max(
    2000,
    i18n.t('validation.error.below2000')
  ),
  listedFlg: yup
    .bool()
    .oneOf([true, false], i18n.t('validation.error.required')),
  prefecture: yup.number(),
  products: yup.array().of(
    yup.object({
      productNames: yup.string().max(250, i18n.t('validation.error.below250')),
      productUrls: yup
        .string()
        .url(i18n.t('validation.error.url'))
        .max(250, i18n.t('validation.error.below250'))
    })
  ),
  representative: yup.string().max(250, i18n.t('validation.error.below250')),
  resources_0: urlValidation.max(250, i18n.t('validation.error.below250')),
  resources_1: urlValidation.max(250, i18n.t('validation.error.below250')),
  resources_2: urlValidation.max(250, i18n.t('validation.error.below250')),
  resources_3: urlValidation.max(250, i18n.t('validation.error.below250')),
  resources_4: urlValidation.max(250, i18n.t('validation.error.below250')),
  sales: yup
    .number()
    .oneOf(
      [1, 10, 20, 30, 40, 50, 60, 70, 80, 90],
      i18n.t('validation.error.required')
    ),
  sns_0: urlValidation.max(250, i18n.t('validation.error.below250')),
  sns_1: urlValidation.max(250, i18n.t('validation.error.below250')),
  sns_2: urlValidation.max(250, i18n.t('validation.error.below250')),
  sns_3: urlValidation.max(250, i18n.t('validation.error.below250')),
  sns_4: urlValidation.max(250, i18n.t('validation.error.below250')),
  zipcode: yup
    .string()
    .matches(/^[0-9]{7}$/, i18n.t('validation.error.zipcode'))
});

export const agentClientRegisterCompanySchema = yup.object().shape({
  address: yup.string().max(250, i18n.t('validation.error.below250')),
  agentFlg: yup
    .bool()
    .oneOf([true, false], i18n.t('validation.error.required')),
  agentLists: yup.string(),
  capital: yup
    .number()
    .nullable()
    .transform(
      (value, originalValue) =>
        (isNaN(Number(originalValue))
          ? originalValue
          : Number(originalValue)) as number
    )
    .test(
      'is-number',
      i18n.t('validation.error.number'),
      (value) =>
        value === undefined ||
        value === null ||
        (value !== undefined && value !== null && !isNaN(Number(value)))
    )
    .min(0, i18n.t('validation.error.above1'))
    .max(1000000000000000, i18n.t('validation.error.below1000000000000000'))
    .typeError(i18n.t('validation.error.number')),
  city: requiredValidation.max(250, i18n.t('validation.error.below250')),
  employees: yup
    .number()
    .nullable()
    .transform(
      (value, originalValue) =>
        (isNaN(Number(originalValue))
          ? originalValue
          : Number(originalValue)) as number
    )
    .test(
      'is-number',
      i18n.t('validation.error.number'),
      (value) =>
        value === undefined ||
        value === null ||
        (value !== undefined && value !== null && !isNaN(Number(value)))
    )
    .min(0, i18n.t('validation.error.above1'))
    .max(100000000, i18n.t('validation.error.below100000000'))
    .typeError(i18n.t('validation.error.number')),
  fiscalMonth: yup.number(),
  foundationYear: yup
    .number()
    .transform((value: number) => (isNaN(value) ? undefined : value))
    .nullable()
    .min(999, i18n.t('validation.error.yearEstablished'))
    .max(10000, i18n.t('validation.error.yearEstablished'))
    .required(i18n.t('validation.error.required')),
  image: imageValidation,
  industryType: yup.number(),
  introduction: requiredValidation.max(
    2000,
    i18n.t('validation.error.below2000')
  ),
  listedFlg: yup
    .bool()
    .oneOf([true, false], i18n.t('validation.error.required')),
  prefecture: yup.number(),
  products: yup.array().of(
    yup.object({
      productNames: yup.string().max(250, i18n.t('validation.error.below250')),
      productUrls: urlValidation.max(250, i18n.t('validation.error.below250'))
    })
  ),
  representative: yup.string().max(250, i18n.t('validation.error.below250')),
  resources_0: urlValidation.max(250, i18n.t('validation.error.below250')),
  resources_1: urlValidation.max(250, i18n.t('validation.error.below250')),
  resources_2: urlValidation.max(250, i18n.t('validation.error.below250')),
  resources_3: urlValidation.max(250, i18n.t('validation.error.below250')),
  resources_4: urlValidation.max(250, i18n.t('validation.error.below250')),
  sales: yup
    .number()
    .oneOf(
      [1, 10, 20, 30, 40, 50, 60, 70, 80, 90],
      i18n.t('validation.error.required')
    ),
  sns_0: urlValidation.max(250, i18n.t('validation.error.below250')),
  sns_1: urlValidation.max(250, i18n.t('validation.error.below250')),
  sns_2: urlValidation.max(250, i18n.t('validation.error.below250')),
  sns_3: urlValidation.max(250, i18n.t('validation.error.below250')),
  sns_4: urlValidation.max(250, i18n.t('validation.error.below250')),
  zipcode: yup
    .string()
    .matches(/^[0-9]{7}$/, i18n.t('validation.error.zipcode'))
});

export const clientRegisterCompanySchemaWhenAgent = yup.object().shape({
  address: yup
    .string()
    .max(250, i18n.t('validation.error.below250'))
    .nullable(),
  agentFlg: yup
    .bool()
    .oneOf([true, false], i18n.t('validation.error.required')),
  agentLists: yup.string(),
  capital: yup
    .number()
    .nullable()
    .transform(
      (value, originalValue) =>
        (isNaN(Number(originalValue))
          ? originalValue
          : Number(originalValue)) as number
    )
    .test(
      'is-number',
      i18n.t('validation.error.number'),
      (value) =>
        value === undefined ||
        value === null ||
        (value !== undefined && value !== null && !isNaN(Number(value)))
    )
    .min(0, i18n.t('validation.error.above1'))
    .max(1000000000000000, i18n.t('validation.error.below1000000000000000'))
    .typeError(i18n.t('validation.error.number')),
  city: requiredValidation.max(250, i18n.t('validation.error.below250')),
  employees: yup
    .number()
    .nullable()
    .transform(
      (value, originalValue) =>
        (isNaN(Number(originalValue))
          ? originalValue
          : Number(originalValue)) as number
    )
    .test(
      'is-number',
      i18n.t('validation.error.number'),
      (value) =>
        value === undefined ||
        value === null ||
        (value !== undefined && value !== null && !isNaN(Number(value)))
    )
    .min(0, i18n.t('validation.error.above1'))
    .max(100000000, i18n.t('validation.error.below100000000'))
    .typeError(i18n.t('validation.error.number')),
  fiscalMonth: yup.number().nullable(),
  foundationYear: yup
    .number()
    .transform((value: number) => (isNaN(value) ? undefined : value))
    .nullable()
    .min(999, i18n.t('validation.error.yearEstablished'))
    .max(10000, i18n.t('validation.error.yearEstablished'))
    .required(i18n.t('validation.error.required')),
  image: imageValidation,
  industryType: yup.number(),
  introduction: yup
    .string()
    .nullable()
    .max(2000, i18n.t('validation.error.below2000')),
  listedFlg: yup
    .bool()
    .oneOf([true, false], i18n.t('validation.error.required')),
  prefecture: yup.number(),
  products: yup.array().of(
    yup.object({
      productNames: yup.string().max(250, i18n.t('validation.error.below250')),
      productUrls: yup
        .string()
        .url(i18n.t('validation.error.url'))
        .max(250, i18n.t('validation.error.below250'))
    })
  ),
  representative: yup.string().max(250, i18n.t('validation.error.below250')),
  resources_0: urlValidation
    .nullable()
    .max(250, i18n.t('validation.error.below250')),
  resources_1: urlValidation
    .nullable()
    .max(250, i18n.t('validation.error.below250')),
  resources_2: urlValidation
    .nullable()
    .max(250, i18n.t('validation.error.below250')),
  resources_3: urlValidation
    .nullable()
    .max(250, i18n.t('validation.error.below250')),
  resources_4: urlValidation
    .nullable()
    .max(250, i18n.t('validation.error.below250')),
  sales: yup.number().nullable(),
  sns_0: urlValidation.nullable().max(250, i18n.t('validation.error.below250')),
  sns_1: urlValidation.nullable().max(250, i18n.t('validation.error.below250')),
  sns_2: urlValidation.nullable().max(250, i18n.t('validation.error.below250')),
  sns_3: urlValidation.nullable().max(250, i18n.t('validation.error.below250')),
  sns_4: urlValidation.nullable().max(250, i18n.t('validation.error.below250')),
  zipcode: yup
    .string()
    .matches(/^[0-9]{7}$/, i18n.t('validation.error.zipcode'))
});

export const clientRegisterEditSchema = yup.object().shape({
  address: yup
    .string()
    .transform((value: string | null) => (value === null ? '' : value))
    .max(250, i18n.t('validation.error.below250')),
  agentFlg: yup
    .bool()
    .oneOf([true, false], i18n.t('validation.error.required')),
  agentLists: yup.string(),
  bgImg: imageValidation,
  city: requiredValidation.max(250, i18n.t('validation.error.below250')),
  companyName: requiredValidation.max(250, i18n.t('validation.error.below250')),
  companyUrl: urlValidation
    .required(i18n.t('validation.error.required'))
    .max(250, i18n.t('validation.error.below250')),
  department: yup
    .string()
    .transform((value: string | null) => (value === null ? '' : value))
    .max(250, i18n.t('validation.error.below250')),
  employees: yup
    .string()
    .nullable()
    .matches(/^[0-9,]*$/, i18n.t('validation.error.number')),
  fiscalMonth: yup.number().nullable(),
  foundationYear: yup
    .number()
    .transform((value: number) => (isNaN(value) ? undefined : value))
    .nullable()
    .min(999, i18n.t('validation.error.yearEstablished'))
    .max(10000, i18n.t('validation.error.yearEstablished'))
    .required(i18n.t('validation.error.required')),
  industry: yup.number().required(i18n.t('validation.error.required')),
  industryOther: yup.string().when('industry', {
    is: 99,
    otherwise: yup.string().nullable(),
    then: requiredValidation
      .transform((value: string | null) => (value === null ? '' : value))
      .max(250, i18n.t('validation.error.below250'))
  }),
  introduction: requiredValidation.max(
    2000,
    i18n.t('validation.error.below2000')
  ),
  listedFlg: yup
    .bool()
    .oneOf([true, false], i18n.t('validation.error.required')),
  logo: imageValidation,
  prefecture: yup.number(),
  products: yup.array().of(
    yup.object({
      productNames: yup.string().max(250, i18n.t('validation.error.below250')),
      productUrls: urlValidation.max(250, i18n.t('validation.error.below250'))
    })
  ),
  representativeName: requiredValidation.max(
    250,
    i18n.t('validation.error.below250')
  ),
  resources_0: urlValidation
    .transform((value: string | null) => (value === null ? '' : value))
    .max(250, i18n.t('validation.error.below250')),
  resources_1: urlValidation
    .transform((value: string | null) => (value === null ? '' : value))
    .max(250, i18n.t('validation.error.below250')),
  resources_2: urlValidation
    .transform((value: string | null) => (value === null ? '' : value))
    .max(250, i18n.t('validation.error.below250')),
  resources_3: urlValidation
    .transform((value: string | null) => (value === null ? '' : value))
    .max(250, i18n.t('validation.error.below250')),
  resources_4: urlValidation
    .transform((value: string | null) => (value === null ? '' : value))
    .max(250, i18n.t('validation.error.below250')),
  sales: yup
    .number()
    .oneOf(
      [1, 10, 20, 30, 40, 50, 60, 70, 80, 90],
      i18n.t('validation.error.required')
    ),
  sns_0: urlValidation
    .transform((value: string | null) => (value === null ? '' : value))
    .max(250, i18n.t('validation.error.below250')),
  sns_1: urlValidation
    .transform((value: string | null) => (value === null ? '' : value))
    .max(250, i18n.t('validation.error.below250')),
  sns_2: urlValidation
    .transform((value: string | null) => (value === null ? '' : value))
    .max(250, i18n.t('validation.error.below250')),
  sns_3: urlValidation
    .transform((value: string | null) => (value === null ? '' : value))
    .max(250, i18n.t('validation.error.below250')),
  sns_4: urlValidation
    .transform((value: string | null) => (value === null ? '' : value))
    .max(250, i18n.t('validation.error.below250')),
  zipcode: yup
    .string()
    .matches(/^[0-9]{7}$/, i18n.t('validation.error.zipcode'))
});

export const publisherRegisterEditSchema = yup.object().shape({
  address: yup
    .string()
    .nullable()
    .max(250, i18n.t('validation.error.below250')),
  bgImg: imageValidation,
  capital: yup
    .number()
    .nullable()
    .transform(
      (value, originalValue) =>
        (isNaN(Number(originalValue))
          ? originalValue
          : Number(originalValue)) as number
    )
    .test(
      'is-number',
      i18n.t('validation.error.number'),
      (value) =>
        value === undefined ||
        value === null ||
        (value !== undefined && value !== null && !isNaN(Number(value)))
    )
    .min(0, i18n.t('validation.error.above1'))
    .max(1000000000000000, i18n.t('validation.error.below1000000000000000'))
    .typeError(i18n.t('validation.error.number')),
  city: requiredValidation.max(250, i18n.t('validation.error.below250')),
  companyName: requiredValidation.max(250, i18n.t('validation.error.below250')),
  companyUrl: urlValidation
    .required(i18n.t('validation.error.required'))
    .max(250, i18n.t('validation.error.below250')),
  employees: yup
    .string()
    .nullable()
    .matches(/^[0-9,]*$/, i18n.t('validation.error.number')),
  foundationYear: yup
    .number()
    .transform((value: number) => (isNaN(value) ? undefined : value))
    .nullable()
    .min(999, i18n.t('validation.error.yearEstablished'))
    .max(10000, i18n.t('validation.error.yearEstablished'))
    .required(i18n.t('validation.error.required')),
  industry: yup.number().required(i18n.t('validation.error.required')),
  industryOther: yup.string().when('industry', {
    is: 99,
    otherwise: yup.string().nullable(),
    then: requiredValidation
      .transform((value: string | null) => (value === null ? '' : value))
      .max(250, i18n.t('validation.error.below250'))
  }),
  introduction: requiredValidation.max(
    2000,
    i18n.t('validation.error.below2000')
  ),
  listedFlg: yup
    .bool()
    .oneOf([true, false], i18n.t('validation.error.required')),
  logo: imageValidation,
  prefecture: yup.number(),
  president: yup
    .string()
    .nullable()
    .max(250, i18n.t('validation.error.below250')),
  representativeName: requiredValidation.max(
    250,
    i18n.t('validation.error.below250')
  ),
  resources_0: urlValidation
    .transform((value: string | null) => (value === null ? '' : value))
    .max(250, i18n.t('validation.error.below250')),
  resources_1: urlValidation
    .transform((value: string | null) => (value === null ? '' : value))
    .max(250, i18n.t('validation.error.below250')),
  resources_2: urlValidation
    .transform((value: string | null) => (value === null ? '' : value))
    .max(250, i18n.t('validation.error.below250')),
  resources_3: urlValidation
    .transform((value: string | null) => (value === null ? '' : value))
    .max(250, i18n.t('validation.error.below250')),
  resources_4: urlValidation
    .transform((value: string | null) => (value === null ? '' : value))
    .max(250, i18n.t('validation.error.below250')),
  sales: yup.number(),
  sns_0: urlValidation
    .transform((value: string | null) => (value === null ? '' : value))
    .max(250, i18n.t('validation.error.below250')),
  sns_1: urlValidation
    .transform((value: string | null) => (value === null ? '' : value))
    .max(250, i18n.t('validation.error.below250')),
  sns_2: urlValidation
    .transform((value: string | null) => (value === null ? '' : value))
    .max(250, i18n.t('validation.error.below250')),
  sns_3: urlValidation
    .transform((value: string | null) => (value === null ? '' : value))
    .max(250, i18n.t('validation.error.below250')),
  sns_4: urlValidation
    .transform((value: string | null) => (value === null ? '' : value))
    .max(250, i18n.t('validation.error.below250')),
  zipcode: yup
    .string()
    .matches(/^[0-9]{7}$/, i18n.t('validation.error.zipcode'))
});
